import React, {useState, useCallback, useEffect, useRef} from 'react';
import {
    RACK_NODE_OUTPUT,
    RACK_MODULATOR_OUTPUT,
    RACK_NODE_INPUT,
} from 'constants/contextual-help.js';
import {
    setParameterToMap,
    setContextualHelp} from "actions/index.js";
import {connect} from 'react-redux';
import Tooltip from './Tooltip.js';
import { Arrow, Text, Circle, Group, Stage, Layer, FastLayer, Rect, Line} from 'react-konva';
import {
    INPUT,
    OUTPUT,
    NODE_HEIGHT,
    NODE_WIDTH,
    NODE_HEIGHTS} from './constants.js';

const TOOLTIP_DELAY = 300;

function NodeIO({
    x,
    y,
    number,
    mode,
    parameter,
    startDrawingEdge,
    drawingEdge,
    rack,
    effect,
    isModulator,
    selectedEdge,
    connectEdge,
    setContextualHelp,
    isMacroMapping,
    setParameterToMap
    }) {

    const [isHovered, setIsHovered] = useState(false);
    const [showThumbnail, setShowThumbnail] = useState(false);
    const [delayHandler, setDelayHandler] = useState(null)

    y = mode === INPUT ? y : isModulator ?
        y + NODE_HEIGHT : y + NODE_HEIGHTS[rack.getEffectType()];

    const onMouseOver = useCallback(() => {
        setIsHovered(true);
        setDelayHandler(setTimeout(() => {
            setShowThumbnail(true);
        }, TOOLTIP_DELAY));
        setContextualHelp(
            mode === INPUT ?
                RACK_NODE_INPUT :
                isModulator ? RACK_MODULATOR_OUTPUT : RACK_NODE_OUTPUT);
    }, [setIsHovered, isHovered, setDelayHandler, setShowThumbnail]);

    const onMouseLeave = useCallback((h) => {
        clearTimeout(delayHandler);
        setShowThumbnail(false);
        setIsHovered(false);
        setContextualHelp(undefined);
    }, [setIsHovered, setShowThumbnail, delayHandler]);

    const onMouseDown = useCallback((e) => {
        if (isMacroMapping) {
            e.stopPropagation();
            setParameterToMap(parameter);
        }
        startDrawingEdge(effect, mode, x + number * 8, y, number - 1);
    }, [startDrawingEdge, setShowThumbnail, effect, mode, number, x, y, isMacroMapping]);

    if (selectedEdge && selectedEdge.effect && 
        (selectedEdge.effect.id === effect.id ||
         selectedEdge.fromNode === effect)) {
        return [];
    }

    return (
        <g>
          <circle
            className={isMacroMapping ? "node-io mapping" : "node-io"}
            strokeWidth={isHovered ? 2 : 0}
            stroke={isHovered ? "yellow" : "black"}
            cx={x + number * 8}
            onMouseDown={onMouseDown}
            onMouseOver={isHovered ? () => [] : onMouseOver}
            onMouseLeave={onMouseLeave}
            onMouseUp={() => connectEdge(parameter || effect, mode)}
            cy={y}
            r={3}
            fill="#626363"
            />
          {showThumbnail ? <Tooltip isRule={rack.name === "Rules Rack"} number={number} parameter={parameter} mode={mode} x={x + number * 8} y={y+20}/> :
            <rect x={0} y={0} width={0} height={0}/>}
        </g>
    );
}

const mapDispatchToProps = (dispatch) => {
  return {
      setContextualHelp: (element, arg) => dispatch(setContextualHelp(element, arg)),
      setParameterToMap: parameter => dispatch(setParameterToMap(parameter)),
  };
};

export default connect(null, mapDispatchToProps)(NodeIO);

